import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

	/**
	 * @description
	 *	Transforma una fecha en una representación más legible y compacta.
	 */

@Pipe({ name: "timestamp", pure: true })
export class TimestampPipe implements PipeTransform {

	public constructor(private datePipe: DatePipe) {}

	/**
	 * @description
	 *	Transforma una fecha y su hora en un formato compacto para una mejor
	 *	visualización.
	 *
	 * @param date
	 *	La fecha, posiblemente sin especificar.
	 * @param orElse
	 *	Resultado a devolver si la fecha no fue especificada.
	 *
	 * @returns
	 *	La representación compacta de la fecha, o la cadena indicada en el
	 *	parámetro 'orElse', si la fecha es 'null' o 'undefined'.
	 */
	public transform(date: Date, orElse: string = "[no disponible]"): string {
		if (date === null || date === undefined) {
			return orElse;
		}
		else {
			return this.datePipe.transform(date, "dd/MM/yyyy, HH:mm:ss", "-0300");
		}
	}
}
